export interface AppUpdateConfig {
  VersionCode?: number
  Titulo?: string
  Descripcion?: string
  Boton?: string
  Imagen?: string
  Wallpaper?: string
  Platform?: {
    ios?: string
    android?: string
  }
}

export interface IMaintenanceScreen {
  Activo: boolean
  ColorFondo?: string
  Descripcion: string
  Imagen: string
  StyleImg?: { }
}

export const DefaultMaintenanceScreen: IMaintenanceScreen = {
  Activo:  true,
  ColorFondo:  'gray',
  Descripcion:  '<p><b>En mantenimiento</b></p> <p>Estamos trabajando, ya casi terminamos</p>',
  // tslint:disable-next-line: max-line-length
  Imagen:  'iconos/mantenimiento.svg',
  StyleImg: { width: '77px', margin: '0 auto' }
}
